import { Avatar, Box, Dialog, IconButton, Slide } from '@mui/material'
import { useEffect, useState, forwardRef } from 'react'
import { rqx } from '../../../../../../../core/request/API';
import { env } from '../../../../../../../core/Env';
import { CommentLoader } from '../../../../../publication/view/devices/mobile/comment/Loader';
import { KeyboardBackspace } from '@mui/icons-material';
import DOMPurify from 'dompurify';
import { timeFormat } from '../../../../../../../core/global/Format';

const SlideTransition = forwardRef(function SlideTransition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const Comment = ({ decodePath, showComment, setShowComment }) => {
    const [isLoader, setIsLoader] = useState(false)
    const [commentList, setCommentList] = useState([])
    const [expanded, setExpanded] = useState(false);
    
    const getComment = async () => {
        setIsLoader(true);
        const data = await rqx.get(`<<tool>>/${env()}/psl/publicationComment/readComment`,{ publication_id: decodePath, lastId: 0, limit: 100 });
        setCommentList(data);
        setIsLoader(false);
    };

    useEffect(() => {
        getComment()
    
        // eslint-disable-next-line
    },[])
    
    const timePosted = commentList.length > 0 ? timeFormat(commentList[0].created_at) : "N/A";
    const userName = commentList.length ? `${commentList[0].first_name} ${commentList[0].last_name}` : 'User Hero'
    
    const cleanCommentFormat = (text) => {        
        if (!/<[a-z][\s\S]*>/i.test(text)) {
            text = text.replace(/\n/g, '<br />');
            text = text.replace(
                /(https?:\/\/[^\s]+)/g,
                '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
            );
        }

        const sanitized = DOMPurify.sanitize(text, {
            ALLOWED_TAGS: [
                'p', 'a', 'br', 'strong', 'em', 'ul', 'ol', 'li',
                'h1', 'h2', 'h3', 'blockquote', 'dl', 'dt', 'dd', 'pre', 'code', 'dfn', 'span'
            ],
            ALLOWED_ATTR: ['href', 'target', 'rel', 'cite']
        });

        
        if (!expanded && sanitized.length > 500) {
            return `${sanitized.slice(0, 500)}...<span style="color:#1976d2;cursor:pointer;font-size:12px;" id="see-more">See more</span>`;
        }

        return sanitized;
    };

    const handleClick = (e) => {
        if (e.target.id === 'see-more') {
            setExpanded(true);
        }
    };

    return (
        <Dialog open={showComment} fullScreen TransitionComponent={SlideTransition} PaperProps={{sx:{zIndex: 3}}}>
            <Box>
                <Box bgcolor="#FFFFFF" display="flex" justifyContent="space-between" alignItems="center" p="8px 16px" position="sticky" top="0px" zIndex={3}>
                    <IconButton onClick={() => setShowComment(false)}> <KeyboardBackspace/></IconButton>
                    <Box fontSize="12px" fontWeight="600">{`Comment ${commentList.length > 0 ? `(${commentList.length})` : '' }`}</Box>
                    <Box sx={{ width: 40 }} />
                </Box>
                    {
                        isLoader ?
                        <Box height="100%" p="8px 16px" display="flex" flexDirection="column" gap="24px">
                            {
                                Array(3).fill(0).map((_, i) => (
                                    <CommentLoader key={i}/>
                                ))
                            }
                        </Box>
                    :
                    <Box height="100%" p="8px 16px" display="flex" flexDirection="column" gap="24px">
                        {
                            commentList.length > 0 ?
                                commentList.map((v, i) => (
                                    <Box key={i} width="100%" display="flex" flexDirection="column" gap="12px">
                                        <Box width="100%" display="flex" justifyContent="space-between">
                                            <Box display="flex" alignItems="center" gap="12px" >
                                                <Avatar src={v.profile !== null ? JSON.parse(v.profile).profile : null} sx={{height: '32px', width: '32px'}}/>
                                                <Box>
                                                    <Box fontSize="14px" fontWeight="600">{userName}</Box>
                                                    <Box fontSize="10px" color="#8F969D">{timePosted}</Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box
                                            sx={{
                                                fontSize: '12px',
                                                width:"100%"
                                            }}
                                            className="story-html"
                                            onClick={handleClick}
                                            dangerouslySetInnerHTML={{ __html: cleanCommentFormat(v.comment) }}
                                        />
                                    </Box>
                                ))
                            :
                                <Box height="100%" display="flex" justifyContent="center" alignItems="center">
                                    <Box fontSize="12px" fontWeight="600">No Comment found</Box>
                                </Box>
                        }
                    </Box>
                        
                    }
            </Box>
        </Dialog>
    )
}